export default __webpack_public_path__ + "static/media/photo--sm--115.e4aa44e6.jpg";